module.exports = __webpack_public_path__ + "static/img/success.52d52ed5.png";